import { ComponentProps } from 'react';

export function ZipPayLongIcon({ className, ...props }: ComponentProps<'svg'>) {
	return (
		<svg viewBox="0 0 768 285" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
			<g clipPath="url(#a)">
				<path
					fill="#000"
					d="m19.53 227.27 6.66 54.26h233.17l-7.63-62.14H143.01l-.95-7.7 100.13-69.97-6.69-54.36H2.35l7.63 62.13h108.9l.95 7.77-100.3 70.01Z"
				/>
				<path fill="#AA8FFF" d="m262.59 87.36 23.85 194.17h233.34L495.93 87.36H262.59Z" />
				<path
					fill="#000"
					d="M764.47 157.26c-5.38-43.64-39.66-70.09-86.26-69.9H523l23.84 194.18h69.83l-4.78-38.84h73.89c58.15-.01 84.76-36.24 78.69-85.44Zm-86.24 31-73 .08-5.72-46.6 73.41.06c17.26.21 26.09 9.93 27.52 23.23.88 8.56-3.04 23.22-22.21 23.22v.01ZM332.303 61.56c12.281-13.184 10.14-35.139-4.781-49.038-14.921-13.9-36.973-14.48-49.253-1.296-12.281 13.184-10.14 35.139 4.781 49.038 14.921 13.9 36.973 14.48 49.253 1.296Z"
				/>
			</g>
			<defs>
				<clipPath id="a">
					<path fill="#fff" d="M0 0h768v285H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
